import API from 'service/api';
import { useState, useEffect } from 'react';
import ProfitReportViewContent from './ProfitReportViewContent';

const ProfitReportView = () => {
  const [data, setData] = useState(null);

  // load data
  useEffect(() => {
    API.getReportProfit().then(setData);
  }, []);

  return (<>
    <h1>報表 - 營業額</h1>
    <ProfitReportViewContent data={data} />
  </>);
}

export default ProfitReportView;